module.exports = __webpack_public_path__ + "img/img13.e019f9a2.svg";